"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mapper_1 = __importDefault(require("./mapper"));
const elasticsearch_1 = require("@elastic/elasticsearch");
//@ts-ignore
const aws_elasticsearch_connector_1 = require("aws-elasticsearch-connector");
class ESDBMapper extends mapper_1.default {
    constructor(name, schema, config) {
        super(name, schema, config);
        this.hasSubIndex = false;
        this.es = new elasticsearch_1.Client({
            node: 'https://' + this.config.host,
            requestTimeout: 5000,
            Connection: aws_elasticsearch_connector_1.AmazonConnection,
            Transport: aws_elasticsearch_connector_1.AmazonTransport
        });
    }
    async load(ID, index) {
        const models = await this.query({
            conditions: {
                [`${this.getIDFieldName()}.keyword`]: ID
            },
            size: 1,
            index
        });
        if (!models.length)
            return;
        return models[0];
    }
    async loadByRawID(ID, index) {
        const result = await this.es.get({
            index: this.getDBName() + `${index ? `-${index}` : ''}`,
            id: ID
        });
        if (!result || !result.body)
            return;
        return this.newModel(Object.assign(Object.assign({ ID }, result.body._source), { _index: result.body._index }), 'loaded');
    }
    loadBatch(IDs, index) {
        return this.query({
            conditions: {
                [`${this.getIDFieldName()}.keyword`]: {
                    comparator: 'IN',
                    value: IDs
                }
            },
            index
        });
    }
    getDBName() {
        return this.name;
    }
    query(query) {
        const payload = {
            index: this.getDBName() + `${query.index ? `-${query.index}` : `${this.hasSubIndex ? '*' : ''}`}`,
            size: query.size || 1000,
            body: {
                query: this.getQueryObject(query.conditions),
            },
            sort: query.sort ? `${query.sort}:${query.ascending ? 'asc' : 'desc'}` : undefined,
        };
        return this.es.search(payload).then((response) => {
            var _a, _b, _c;
            let hits = (_c = (_b = (_a = response === null || response === void 0 ? void 0 : response.body) === null || _a === void 0 ? void 0 : _a.hits) === null || _b === void 0 ? void 0 : _b.hits) !== null && _c !== void 0 ? _c : [];
            console.log('ElasticSearch query completed, found hits: ' + hits.length);
            return hits.map(h => this.newModel(Object.assign({ ID: h._id, _index: h._index }, h._source), 'loaded'));
        });
    }
    async commit(model) {
        const ID = model[super.getIDFieldName()];
        console.log(`committing ${this.name} with ID ${ID} and ES ID ${model.ID} to ES`);
        const body = model.toDB();
        delete body.ID;
        return await this.es.index({
            index: model._index || this.getIndex(model),
            id: model.ID,
            body: body,
        });
    }
    async delete(model) {
        const ID = model[super.getIDFieldName()];
        console.log(`deleting ${this.name} with ID ${ID} from ES`);
        return await this.es.delete({
            index: model._index || this.getIndex(model),
            id: model.ID
        });
    }
    getQueryObject(search) {
        const bool = {};
        Object.keys(search).forEach(key => {
            const condition = search[key];
            if (typeof condition !== 'object') {
                if (!bool.must)
                    bool.must = [];
                bool.must.push(this.getSubObject(key, {
                    comparator: '=',
                    value: condition
                }));
            }
            else if (Array.isArray(condition)) {
                if (!bool.must)
                    bool.must = [];
                condition.forEach(s => {
                    bool.must.push(this.getSubObject(key, {
                        comparator: '=',
                        value: s,
                    }));
                });
            }
            else {
                const name = this.getInitialObjectName(condition.comparator);
                if (!bool[name])
                    bool[name] = [];
                bool[name].push(this.getSubObject(key, condition));
            }
        });
        return {
            bool,
        };
    }
    getSubObject(name, searchObj) {
        let { comparator, value, fields } = searchObj;
        let value1 = Array.isArray(value) ? value[0] : value;
        let value2 = Array.isArray(value) ? value[1] : undefined;
        const obj = {};
        switch (comparator) {
            case '=':
            case '!=':
                const objName = this.determineTextObjName(value1);
                if (typeof value1 === 'string' && objName === 'prefix') {
                    value1.replace('*', '');
                }
                obj[objName] = {};
                obj[objName][name] = value1;
                return obj;
            case 'CONTAINS':
            case '!CONTAINS':
                if (String(value1).split(' ').length > 1) {
                    let arr = [];
                    String(value1).split(' ').forEach(part => {
                        let w = {
                            wildcard: {
                                [name]: '*' + part + '*'
                            },
                        };
                        arr.push(w);
                    });
                    return arr;
                }
                else {
                    if (String(value1).indexOf('*') === -1) {
                        value1 += '*';
                    }
                    obj.wildcard = {};
                    obj.wildcard[name] = value1;
                    return obj;
                }
            case '<':
            case '<=':
            case '>':
            case '>=':
            case 'BETWEEN':
                obj.range = {};
                obj.range[name] = {};
                obj.range[name] = this.getRangeObject(comparator, value1, value2);
                return obj;
            case 'EXISTS':
            case '!EXISTS':
                obj.exists = {
                    field: {},
                };
                obj.exists.field = value1;
                return obj;
            case 'IN':
                return {
                    bool: {
                        should: value.map(v => ({
                            match: { [name]: v }
                        }))
                    }
                };
            case '!IN':
                return {
                    bool: {
                        must_not: value.map(v => ({
                            match: { [name]: v }
                        }))
                    }
                };
            case 'MULTI_FIELD':
            case '!MULTI_FIELD':
                if (String(value1).split(' ').length > 1) {
                    return String(value1)
                        .split(' ')
                        .map(part => {
                        return {
                            bool: {
                                should: fields === null || fields === void 0 ? void 0 : fields.map(f => {
                                    return {
                                        wildcard: { [f]: `*${part}*` },
                                    };
                                }),
                            },
                        };
                    });
                }
                // Currently searching for full email addresses with this query doesn't work
                // this should resolve that until we find a better way to go about it.
                if (String(value1).split(/[@-]/).length > 1) {
                    return String(value1)
                        .split(/[@-]/)
                        .map(part => {
                        return {
                            bool: {
                                should: fields === null || fields === void 0 ? void 0 : fields.map(f => {
                                    return {
                                        wildcard: { [f]: `*${part}*` },
                                    };
                                }),
                            },
                        };
                    });
                }
                return {
                    bool: {
                        should: fields === null || fields === void 0 ? void 0 : fields.map(f => {
                            return {
                                wildcard: { [f]: `*${value}*` },
                            };
                        }),
                    },
                };
        }
        return obj;
    }
    getRangeObject(comparator, value1, value2) {
        const range = {};
        if (comparator === '>=' || comparator === 'BETWEEN') {
            range.gte = value1;
        }
        if (comparator === '<=' || comparator === 'BETWEEN') {
            range.lte = comparator === 'BETWEEN' ? value2 : value1;
        }
        if (comparator === '<') {
            range.lt = value1;
        }
        if (comparator === '>') {
            range.gt = value1;
        }
        return range;
    }
    getInitialObjectName(comparator) {
        if (comparator === '!=' || comparator === '!EXISTS' || comparator === '!CONTAINS')
            return 'must_not';
        return 'must';
    }
    determineTextObjName(value) {
        if (String(value).indexOf('*') > -1) {
            return String(value).indexOf('*') === String(value).length - 1 ? 'prefix' : 'wildcard';
        }
        else {
            return 'match';
        }
    }
    getIndex(model) {
        return this.name;
    }
}
exports.default = ESDBMapper;
;
